/* ============================
   Allowed Domains Validators
   ============================ */

export const loadAllowedDomains = () =>
    (process.env.REACT_APP_ALLOWED_DOMAINS || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);

export const isAllowedScannedUrl = (scannedText, allowedList) => {
    if (!scannedText) return false;
    if (!allowedList || allowedList.length === 0) {
        console.warn("No allowed domains configured. Allowing all domains.");
        return true;
    }

    let parsed;
    try {
        parsed = new URL(scannedText);
    } catch {
        return false;
    }

    const { hostname, origin } = parsed;

    return allowedList.some((entry) => {
        if (/^https?:\/\//i.test(entry)) {
            try {
                return new URL(entry).origin === origin;
            } catch {
                return false;
            }
        }
        return hostname === entry || hostname.endsWith(`.${entry}`);
    });
};
